// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"986ceaef","182":"c917689a","767":"0e89f603"}[chunkId] + ".chunk.css";
};